<dp-login [hasError]="hasError"
          [hasLoginMethodsError]="hasOtherLoginError"
          [errorKey]="error"
          [pattern]="pattern"
          [loginMethods]="providers"
          (login)="doLogin($event)"
          (loginMethod)="otherLoginMethod($event)">
</dp-login>
